import { useState, useEffect } from 'react'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import RateBusiness from './RateBusiness'
import RateProfessional from './RateProfessional'
import RatingComplete from './RatingComplete'
import { FaCheck } from 'react-icons/fa'

import {
  Container,
  StepRow,
  StepContainer,
  StepCircle,
  StepLabel,
  StepLine,
  InfoText
} from './styles'

export default function RateScheduleModal ({
  visible,
  schedule,
  navigateTo,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const steps = [
    { number: 1, label: 'Avaliar salão', value: 'rate_business' },
    { number: 2, label: 'Avaliar profissional', value: 'rate_professional' },
    { number: 3, label: 'Avaliação concluída', value: 'rating_complete' }
  ]
  
  const [currentStep, setCurrentStep] = useState (steps[0])
  const [ratings, setRatings] = useState ({})

  useEffect (() => {
    if (navigateTo) {
      const step = steps.find (step => step.value === navigateTo)
      if (step) setCurrentStep (step)
    }
  }, [navigateTo])

  const handleBusinessRated = businessRating => {
    setRatings (prev => ({ ...prev, businessRating }))
    setCurrentStep (steps[1])
  }

  const handleProfessionalRated = professionalRating => {
    setRatings (prev => ({ ...prev, professionalRating }))
    setCurrentStep (steps[2])
  }

  const handleCloseDialog = () => {
    if (currentStep.value === 'rating_complete') {
      handleConfirm (ratings)
    } else {
      handleClose ()
    }
  }

  if (!schedule) return null

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleCloseDialog() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Avaliar atendimento</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <StepRow>
              {steps.map ((step, index) => (
                <StepContainer key={index}>
                  <StepCircle step={step} currentStep={currentStep}>
                    {currentStep.number > step.number ? (
                      <FaCheck color='#FFFFFF' size={18}/>
                    ) : (
                      <InfoText>{step.number}</InfoText>
                    )}
                  </StepCircle>
                  <StepLabel>{step.label}</StepLabel>
                </StepContainer>
              ))}
              <StepLine currentStep={currentStep}/>
            </StepRow>
            {currentStep.value === 'rate_business' && (
              <RateBusiness schedule={schedule} onConfirm={handleBusinessRated}/>
            )}
            {currentStep.value === 'rate_professional' && (
              <RateProfessional schedule={schedule} onConfirm={handleProfessionalRated}/>
            )}
            {currentStep.value === 'rating_complete' && (
              <RatingComplete onConfirm={() => handleConfirm (ratings)}/>
            )}
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
